module.exports = __webpack_public_path__ + "static/media/img184.b1509d0c.jpg";